import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react'
import PropTypes from 'prop-types'
import EditorJS from '@editorjs/editorjs'
import { getEditorJsTools } from '@helpers/editor'
import './blocks.css'

const Editor = forwardRef((props, ref) => {
  const {
    content,
    onSave,
    elementId = 'editorjs',
    exercises = true,
    basic = true,
    onChange,
    autofocus = true,
    minHeight = 20,
    onReady,
    placeholder,
  } = props
  const editorRef = useRef(null)
  const onChangeRef = useRef()

  useEffect(() => {
    if (onChange) {
      onChangeRef.current = onChange
    }
  }, [onChange])

  const handleChange = (api) => {
    // setTimeout(() => {
      // Hack to fix multiline paste bug. See: https://github.com/codex-team/editor.js/issues/1755
      api.saver.save().then((data) => onChangeRef.current && onChangeRef.current(data))
    // }, 100)
  }

  useImperativeHandle(ref, () => ({
    async getContent() {
      if (typeof editorRef?.current?.save === 'function') {
        let isEmpty = true

        for (let i = 0; i < editorRef.current.blocks.getBlocksCount(); i++) {
          if (!editorRef.current.blocks.getBlockByIndex(i).isEmpty) {
            isEmpty = false
            break
          }
        }

        const content = await editorRef.current.save()

        return {
          ...content,
          isEmpty,
        }
      }

      return false
    },
  }))

  const tools = {
    ...(basic ? getEditorJsTools(onSave).basic : null),
    ...(exercises ? getEditorJsTools(onSave).exercises : null),
  }

  useEffect(() => {
    editorRef.current = new EditorJS({
      holder: elementId,
      tools,
      autofocus,
      data:
        typeof content === 'string'
          ? content === ''
            ? {}
            : JSON.parse(content)
          : content,
      minHeight,
      onChange: handleChange,
      onReady: onReady ?? undefined,
      placeholder: placeholder,
    })
  }, [elementId])
  return <div id={elementId} />
})

Editor.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default Editor
